import 'css-chunksrc/client/pages/searchPage/searchResults/milestone/status/styles.scss';export default {
  "status": "_status_1ox95_1",
  "square": "_square_1ox95_9",
  "paragraph": "_paragraph_1ox95_16"
};